if (!customElements.get('gallery-tabs')) {
  customElements.define(
    'gallery-tabs',
    class GalleryTabs extends HTMLElement {
      constructor() {
        super();
        this.tabs = this.querySelectorAll('.gallery-tabs__tab');
        this.panels = this.querySelectorAll('.gallery-tabs__panel');

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', this.onTabClick.bind(this));
        });

        this.initImageLoading();
      }

      initImageLoading() {
        this.querySelectorAll('.gallery-tabs__image').forEach((img) => {
          if (img.complete) {
            img.classList.add('loaded');
          } else {
            img.addEventListener('load', () => img.classList.add('loaded'), { once: true });
            img.addEventListener('error', () => img.classList.add('loaded'), { once: true });
          }
        });
      }

      getActiveSlideIndex(panel) {
        const thumbContainer = panel.querySelector('[id^="GalleryThumbnails"]');
        if (thumbContainer) {
          const thumbItems = thumbContainer.querySelectorAll('[data-target]');
          for (let i = 0; i < thumbItems.length; i++) {
            const btn = thumbItems[i].querySelector('button');
            if (btn && btn.getAttribute('aria-current') === 'true') return i;
          }
        }
        const slides = panel.querySelectorAll('.product-media-item');
        for (let i = 0; i < slides.length; i++) {
          if (slides[i].classList.contains('is-active')) return i;
        }
        return 0;
      }

      onTabClick(event) {
        const clickedTab = event.currentTarget;
        const targetIndex = clickedTab.dataset.tabIndex;

        const previousPanel = this.querySelector('.gallery-tabs__panel.is-active');
        const slideIndex = previousPanel ? this.getActiveSlideIndex(previousPanel) : 0;

        this.tabs.forEach((tab) => {
          const isTarget = tab.dataset.tabIndex === targetIndex;
          tab.classList.toggle('is-active', isTarget);
          tab.setAttribute('aria-selected', isTarget ? 'true' : 'false');
        });

        this.panels.forEach((panel) => {
          const isTarget = panel.dataset.tabIndex === targetIndex;
          panel.classList.toggle('is-active', isTarget);
          panel.hidden = !isTarget;
        });

        const activePanel = this.querySelector(
          `.gallery-tabs__panel[data-tab-index="${targetIndex}"]`
        );
        if (activePanel) {
          const slider = activePanel.querySelector('slider-component');
          if (slider) {
            if (slider.resetPages) slider.resetPages();
            const slides = slider.sliderItemsToShow || Array.from(slider.querySelectorAll('[id^="Slide-"]'));
            const targetSlide = Math.min(slideIndex, slides.length - 1);
            if (slides[targetSlide]) {
              slider.slider.scrollTo({ left: slides[targetSlide].offsetLeft, behavior: 'instant' });
            }
            activePanel.dataset.activeSlide = String(targetSlide);
          }

          const gallery = activePanel.querySelector('media-gallery');
          if (gallery) {
            const mediaItems = gallery.querySelectorAll('[data-media-id]');
            mediaItems.forEach((item) => item.classList.remove('is-active'));
            const clampedIndex = Math.min(slideIndex, mediaItems.length - 1);
            const targetItem = mediaItems[clampedIndex];
            if (targetItem) {
              targetItem.classList.add('is-active');
              const thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
              if (thumbnails) {
                const thumbItems = thumbnails.querySelectorAll('[data-target]');
                thumbnails.querySelectorAll('button').forEach((btn) => btn.removeAttribute('aria-current'));
                const targetThumb = thumbItems[Math.min(slideIndex, thumbItems.length - 1)];
                if (targetThumb) {
                  targetThumb.querySelector('button').setAttribute('aria-current', 'true');
                  const thumbList = thumbnails.querySelector('[id^="Slider-Thumbnails"]');
                  if (thumbList) {
                    thumbList.scrollTo({ left: targetThumb.offsetLeft, behavior: 'instant' });
                  }
                }
              }
            }
          }
        }

        this.dispatchEvent(
          new CustomEvent('tabChanged', {
            detail: { tabIndex: targetIndex },
            bubbles: true,
          })
        );
      }
    }
  );
}
